<ion-buttons [ngClass]="{'direction-column': direction=='column'}">
  <ion-button [ngStyle]="{'font-size':size}" fill="clear" [color]="(button.id || button.name) == selected ? isLastData ? 'sub1' : 'main' : unselectedColor"
    [ngClass]="{'not-yet': button.notYet, 'prod-mode': !util.isDebugMode()}" *ngFor="let button of buttons;" (click)="onClick(button)"> {{button.name}}
  </ion-button>
</ion-buttons>